var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" "),(_vm.isRequired)?_c('span',{staticClass:"field-required",attrs:{"aria-hidden":"true"}},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }